export default {
  data() {
    return {
      roleHeaders: [
        { text: 'Role', value: 'agrName', width: '25%', expandable: true, sortable: false },
        { text: 'Type', value: 'isComposite', sortable: false },
        { text: '', value: 'statusColor', width: '20px', sortable: false },
        { text: '', value: 'userStatusColor', width: '20px', sortable: false },
        { text: 'Description', value: 'text', sortable: false },
        { text: 'Profile', value: 'profile', sortable: false },
        { text: 'Updated', value: 'changeDatim', sortable: false },
        { text: 'Assigned', value: 'assignDatim', sortable: false },
        { text: 'Period', value: 'period', sortable: false },
      ],
      profileHeaders: [
        { text: 'Profile', value: 'profn', width: '25%', expandable: true, sortable: false },
        { text: 'Type', value: 'typ', sortable: false },
        { text: 'Description', value: 'ptext', sortable: false },
        { text: 'Updated', value: 'modDatim', sortable: false },
        { text: 'Assigned', value: 'assignDatim', sortable: false },
        { text: 'Role', value: 'singleRole', sortable: false },
      ],
    };
  },
  computed: {
    upperPanelHeight() {
      return `height: ${(this.height / 5) * 2 - 16}px`;
    },
    lowerPanelHeight() {
      return `height: ${(this.height / 5) * 3 - 16}px`;
    },
    upperTableHeight() {
      return (this.height / 5) * 2 - 50;
    },
    lowerTableHeight() {
      return (this.height / 5) * 3 - 50;
    },
  },
  methods: {
    cssStatusColor(statusColor) {
      if ('G' == statusColor) return 'color: green;';
      if ('Y' == statusColor) return 'color: yellow;';
      if ('R' == statusColor) return 'color: red;';
      return this.$vuetify.theme.isDark ? 'color:white;' : 'color:black;';
    },
  },
};
